import { useMiniChips } from "@website/ui/mini-chips/mini-chips.hook";
import styles from "@website/ui/mini-chips/mini-chips.module.scss";
import { MiniChipsPropertiesType } from "@website/ui/mini-chips/mini-chips.types";
import { deepCompare } from "@website/utils/deep-compare";
import { FC, memo } from "react";

const MiniChips: FC<MiniChipsPropertiesType> = (properties) => {
  const {
    color,
    EndIcon,
    StartIcon,
    selected,
    size,
    variant,
    text,
    className,
    textClassName,
    children,
    transparent,
    tooltip
  } = properties;
  const { endIconProps, rootProps } = useMiniChips(properties);
  return (
    <span
      {...rootProps}
      className={`${styles["mini-chips"]} ${
        styles[variant || "round-accent"]
      } ${styles[size || "medium"]} ${styles[color || "default"]} ${
        selected ? styles["selected"] : ""
      } ${className ?? ""}`}
      style={
        color?.startsWith("#")
          ? {
              color: transparent ? color : "white",
              backgroundColor: transparent ? `${color}20` : color
            }
          : {}
      }
      title={tooltip}
    >
      {StartIcon ? (
        <span className={styles["start-icon"]}>{StartIcon}</span>
      ) : null}
      <span className={textClassName ?? styles["text"]}>
        {text || children}
      </span>
      {EndIcon ? (
        <span {...endIconProps} className={styles["end-icon"]}>
          {EndIcon}
        </span>
      ) : null}
    </span>
  );
};

const MiniChipsMemoized = memo(MiniChips, deepCompare);
export { MiniChipsMemoized as MiniChips };
